/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:57:32
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/countTo.js
 */
export default {
    // countTo 组件
    countTo: {
        startVal: 0,
        endVal: 0,
        duration: 2000,
        autoplay: true,
        decimals: 0,
        useEasing: true,
        decimal: '.',
        color: '#606266',
        fontSize: 22,
        bold: false,
        separator: ''
    }
}
